import React from "react";
import './TopMenu.css';
import IconsSiteFxBTC49 from "../../../static/img/SVG/IconsSiteFxBTC49.svg";
import PhoneMenu from "../HeaderAll/PhoneMenu/PhoneMenu";
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";
import MainMenuArray from "../MainMenu";


const SubmenuWork = (Submenu,lang) => { // Правила по которым создается новый массив при окончании перемещения элементов мышкой
    const result = Array.from(Submenu);
    return result.map(function(SubMenuElement,index) {
        if (SubMenuElement.type === 'terminal')
        {
            return (
                <ChangeLink lang={lang} key={index} to={SubMenuElement.href}  style={{textDecoration: 'none'}} activeClassName="MainMenuElementActiveNow">
                    <div className={'MenuElementTerminal '+ SubMenuElement.type }>
                        <div className='MenuElementTerminalDiv'>
                            <img alt='alt' className='MenuElementTerminalDivImg' src={SubMenuElement.IfIMG} width={SubMenuElement.width}/>
                            <img alt='alt' className='MenuElementTerminalDivImgActive' src={SubMenuElement.IfIMGActive} width={SubMenuElement.width}/>
                            <div className='MenuElementTerminalDivLabel'>
                                {SubMenuElement.Name[lang]}
                            </div>
                        </div>
                    </div>
                </ChangeLink>

            )
        } else {
        return (
            <ChangeLink lang={lang} key={index} to={SubMenuElement.href} style={{textDecoration: 'none'}} activeClassName="MainMenuElementActiveNow">
                <div>
                    <nobr> {SubMenuElement.Name[lang]} </nobr>
                </div>
            </ChangeLink>
        )
    }
    });};


const topMenu = (lang) => MainMenuArray.map(function(MenuElement,index) {
        // console.log('lang',lang);
        // console.log('Submenu',MenuElement);
        // console.log('Submenu',MenuElement.Name);
        // console.log('Submenu',MenuElement.Name[lang]);
        return (
        <div key={index} className='MainMenuElement'>
            <div className="MainMenuElementStick"/>
            <ChangeLink lang={lang} to={MenuElement.href}  style={{textDecoration: 'none'}}><div  className='MainMenuElementTitle'><nobr >{MenuElement.Name[lang]} </nobr></div></ChangeLink>
            <div className={'MainMenuElementMenu ' +  MenuElement.type}>
                    {SubmenuWork(MenuElement.Submenu,lang)}
            </div>
        </div>
    )}
    );


function TopMenu(props) {return (
    <div className="MainMenuOut">
            <div className="MainMenu">
                {topMenu(props.lang)}{/*props.Active,this*/}

                <div className="MainMenuElement MainMenuElement07"><div className="MainMenuElementTitle">ФОРУМ</div></div>
                <div className="MainMenuElement MainMenuElement08"><div className="MainMenuElementTitle"><img alt='alt' className="MainMenuElementFind" src={IconsSiteFxBTC49} width="20px" height="20px" color="white"/></div></div>
                <div className="MainMenuElementPhone"><ChangeLink lang={props.lang} to='/trader/open' style={{textDecoration: 'none'}}><div className="MainMenuElementTitle">Открыть счет</div></ChangeLink></div>
                <div className="MainMenuElementPhone"><ChangeLink lang={props.lang} to='/Invest' style={{textDecoration: 'none'}}><div className="MainMenuElementTitle">Получить инвестиции</div></ChangeLink></div>
                <div className="MainMenuElementPhone MainMenuElementPhoneMenu"><PhoneMenu lang={props.lang}/></div>
            </div>

    </div>
)}

export default TopMenu